import BaseComponent from '../../../general/js/base-component';

export default class RadioSwitchComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.inputs = this.refs.inputs;
        this.labels = this.refs.labels;
        this.bg = this.refs.bg;

        this.init();
    }

    static getRequiredRefs() {
        return ['inputs', 'labels', 'bg'];
    }

    init() {
        this.labels.forEach(label => {
            label.addEventListener("click", this.onClick.bind(this));
        });

        if (this.props.onSwitch) {
            this.inputs.forEach(input => input.addEventListener("change", this.props.onSwitch));
        }
    }

    onClick(e) {
        this.bg.style.left = e.target.offsetLeft + "px";
        this.bg.style.width = e.target.offsetWidth + "px";
    }

    getValue() {
        let value = null;
        let checkedInput = this.inputs.filter(input => input.checked);
        if (checkedInput.length > 0) {
            value = checkedInput[0].value;
        }
        return value;
    }
}



// WEBPACK FOOTER //
// ./app/components/radio-switch/js/radio-switch.component.js